import { computed } from "vue";
import { Contexts } from "@upmind-automation/types";
import type { IState } from "@/store";
import store from "@/store";

export function useContext() {
  const current = computed(() => store.state.context as IState["context"]);

  const isMockClientContext = computed(
    () => store.getters["isMockClientContext"]() as boolean
  );

  const isAdmin = computed(
    () => !isMockClientContext.value && current.value === Contexts.ADMIN
  );

  const isClient = computed(
    () => !!isMockClientContext.value || current.value === Contexts.CLIENT
  );

  const isGuest = computed(() => current.value === Contexts.GUEST);

  return {
    current,
    isMockClientContext,
    isAdmin,
    isClient,
    isGuest
  };
}
